import {MutationTree} from "vuex";
import { DateTime } from "luxon";
import {ProgramState} from "../types/ProgramState";
import Vue from 'vue';
import {Meeting} from "@api/models/meetings/Meeting";

export const mutations: MutationTree<ProgramState> = {
    setProgram(state, {program, date}) {
        Vue.set(state.programs, date, program);
    },
    setCurrentDate(state, payload: DateTime | null) {
        state.currentDate = payload;
    },
    resetPrograms(state) {
        Vue.set(state, "programs", {})
    },
    setSavedMeeting(state, meeting: Meeting | null) {
        state.savedMeeting = meeting;
    }
}